import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { ListDogAnimation } from "../IdAnimDog";
import { StateBuildingGraphics } from "../StateBuildingGraphics";
import { BF2DoghouseDog } from "./BF2DoghouseDog";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
var Container = PIXI.Container;
var dog = new BF2DoghouseDog();
dog.position.set(-30, 120);
dog.playRandomAnimations(ListDogAnimation.Interactive);
export var BF2GetOutskirtBuildingDoghouse = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Doghouse1"];
    var container = new Container();
    var graphics = BF2GetConfigBasedOutskirtBuilding(config);
    dog.updateState(buildingState || StateBuildingGraphics.Idle);
    container.addChild(graphics);
    if (isAccessible) {
        container.addChild(dog);
    }
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingDoghouse.ts
// module id = 2161
// module chunks = 3